import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "m-3" }, {
    title: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("Error 404")
    ])),
    content: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode("ไม่พบหน้าจอที่คุณระบุ ")
    ])),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "ย้อนกลับ",
        onClick: _ctx.onBack
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }))
}